// I │ F Creative Studio — shared behaviour
document.addEventListener('DOMContentLoaded', () => {

  // solid nav on scroll
  const nav = document.querySelector('.site-nav');
  const onScroll = () => {
  if(nav.dataset.forceSolid === 'true' || window.scrollY > 40) nav.classList.add('solid');
  else nav.classList.remove('solid');
};
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});

  // mobile nav toggle
  const burger = document.querySelector('.nav-burger');
  const links = document.querySelector('.nav-links');
  if(burger){
    burger.addEventListener('click', () => {
      const open = links.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      links.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
    }));
    document.addEventListener('keydown', (e) => {
      if(e.key === 'Escape' && links.classList.contains('open')){
        links.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  }

  // scroll reveal
  const revealEls = document.querySelectorAll('.reveal');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(prefersReducedMotion){
    revealEls.forEach(el => el.classList.add('in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          const parent = entry.target.parentElement;
          if(parent && parent.classList.contains('reveal-stagger')){
            const idx = Array.from(parent.children).indexOf(entry.target);
            entry.target.style.setProperty('--i', idx);
          }
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:.15});
    revealEls.forEach(el => io.observe(el));
  }

  // lightbox for case study plates
  const lightbox = document.querySelector('.lightbox');
  if(lightbox){
    const lbImg = lightbox.querySelector('img');
    const closeBtn = lightbox.querySelector('.lightbox-close');
    let lastTrigger = null;
    const openLightbox = (trigger) => {
      lastTrigger = trigger;
      lbImg.src = trigger.dataset.lightbox;
      lbImg.alt = trigger.querySelector('img')?.alt || '';
      lightbox.classList.add('open');
      closeBtn.focus();
    };
    const closeLightbox = () => {
      lightbox.classList.remove('open');
      if(lastTrigger) lastTrigger.focus();
    };
    document.querySelectorAll('[data-lightbox]').forEach(trigger => {
      trigger.addEventListener('click', () => openLightbox(trigger));
      trigger.addEventListener('keydown', (e) => {
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openLightbox(trigger); }
      });
    });
    lightbox.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', (e) => {
      if(e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
    });
  }

});
